import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const HOUR_OF_DAY_VIDEO_REPORT_ID = `hour-of-day${VIDEO_CAMPAIGN_SUFFIX}`;
